import { render, staticRenderFns } from "./xljk.vue?vue&type=template&id=68c64548"
import script from "./xljk.vue?vue&type=script&lang=js"
export * from "./xljk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports